export default "__VITE_ASSET__QYshqik3__"